import {hideRangeScale} from "../form/hideRangeScale";

export function setPrice(e, input, range, scale, button) {
    e.preventDefault();

    range.forEach((item, idx) => {
        if (item.checked) {
            if ((range.length - 1) === idx) {
                button.classList.add('single');
                button.querySelector('span').innerHTML = ''
                button.querySelector('span').innerHTML = '$' + item.value;
                button.dataset.value = '$' + item.value;
            } else {
                button.classList.add('multiple');
                button.querySelector('span').innerHTML = ''
                button.querySelector('span').append(createEl('$1000'));
                button.querySelector('span').append(createEl('$' + item.value));
                button.dataset.value = '$1000, ' + '$' + item.value;
            }
        }
    })

    hideRangeScale(e.target, input, scale);

    function createEl(val) {
        let i = document.createElement('i');
        i.innerHTML = val;

        return i
    }
}
